import {GetPremiumStatusCommand, type GetPremiumStatusResponse} from '@perfectpost/perfect-post-common';
import {useQuery} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {sessionKeys} from '../keys';
import {useAuthenticatedUserQuery} from './useAuthenticatedUserQuery';

/**
 * Les faits serveur du verdict premium : abonnement Stripe, pause, essai,
 * licence d'équipe et appartenance au groupe Cognito `CUSTOMER`.
 *
 * Les thunks `authentification` et `refreshCognitoSession` de
 * `src/store/mainslice.ts` les demandaient à chaque (re)connexion, puis
 * appliquaient la règle partagée `resolvePremiumStatus` — la même source et la
 * même règle que l'API et l'extension. Le payload de `GetMe` ne porte pas la
 * licence d'équipe : sans cet appel, un membre d'équipe sans abonnement
 * personnel serait vu comme gratuit.
 *
 * L'appel peut échouer sans bloquer la session : `SessionProvider` retombe
 * alors sur les faits locaux (profil + groupes du jeton), comme le faisait le
 * `catch` des thunks.
 *
 * Même porte que `useMeQuery` : rien ne part sans utilisateur Cognito connu
 * d'Amplify (cf. `useAuthenticatedUserQuery`).
 */
export function usePremiumStatusQuery() {
  const {data: authenticated} = useAuthenticatedUserQuery();
  return useQuery({
    queryKey: sessionKeys.premiumStatus(),
    queryFn: (): Promise<GetPremiumStatusResponse> => sendOrThrow(new GetPremiumStatusCommand()),
    enabled: authenticated === true,
  });
}
